import {
   Component,
   Input,
   ContentChildren,
   QueryList,
   ViewChild,
   ViewContainerRef,
   AfterViewInit,
   ComponentFactoryResolver,
   ContentChild,
   AfterContentInit
} from '@angular/core';
import { PresenterService } from 'kmm-corp-api';

@Component({
   selector: 'kmm-dx-grid-column-template',
   template: '<ng-content select="[item]"></ng-content>'
})
export class GridColumnTemplate implements AfterContentInit {

   @ContentChild('item', { static: true, }) item: any;

   @Input() context: any;

   ngAfterContentInit() {
   }

}

@Component({
   selector: 'kmm-dx-grid-column',
   template: '<ng-content select="[template]"></ng-content>'
})
export class GridColumnComponent implements AfterContentInit {

   @ContentChild(GridColumnTemplate, { static: true, }) template: GridColumnTemplate;

   @Input() add: boolean = false;
   @Input() templateComponent: any;

   @Input() alignment: string;
   @Input() allowEditing: boolean;
   @Input() allowExporting: boolean;
   @Input() allowFiltering: boolean;
   @Input() allowFixing: boolean;
   @Input() allowGrouping: boolean;
   @Input() allowHeaderFiltering: boolean;
   @Input() allowHiding: boolean;
   @Input() allowReordering: boolean;
   @Input() allowResizing: boolean;
   @Input() allowSearch: boolean;
   @Input() allowSorting: boolean;
   @Input() autoExpandGroup: boolean;
   @Input() buttons: Array<any>;
   @Input() calculateCellValue: Function;
   @Input() calculateDisplayValue: Function;
   @Input() calculateFilterExpression: Function;
   @Input() calculateGroupValue: Function;
   @Input() calculateSortValue: Function;
   @Input() caption: string;
   @Input() cellTemplate: any;
   @Input() columns: Array<GridColumnComponent>;
   @Input() cssClass: string;
   @Input() customizeText: Function;
   @Input() dataField: string;
   @Input() dataType: string;
   @Input() editCellTemplate: string;
   @Input() editorOptions: string;
   @Input() encodeHtml: boolean;
   @Input() falseText: string;
   @Input() filterOperations: Array<string>;
   @Input() filterType: string;
   @Input() filterValue: any;
   @Input() filterValues: Array<any>;
   @Input() fixed: boolean;
   @Input() fixedPosition: string;
   @Input() format: any;
   @Input() lookup: any;
   @Input() name: string;
   @Input() options: any;
   @Input() showEditorAlways: boolean;
   @Input() trueText: string;
   @Input() validationRules: Array<any>;
   @Input() visible: boolean;
   @Input() width: number | string;

   constructor() { }

   ngAfterContentInit() {
   }

}

@Component({
   selector: 'kmm-dx-grid-templates',
   template: '<ng-content select="[template]"></ng-content>'
})
export class GridTemplate {

   @ContentChildren('template') templates: QueryList<any>;

}

@Component({
   selector: 'kmm-dx-grid-options-column',
   template: ''
})
export class GridOptionsColumn extends GridColumnComponent {

}

@Component({
   selector: 'kmm-dx-custom-item',
   template: '<ng-container #componentContainer></ng-container>'
})
export class CustomItem implements AfterViewInit {

   @ViewChild('componentContainer', { static: true, read: ViewContainerRef }) componentContainer: ViewContainerRef;

   @Input() component: any;
   @Input() context: any;
   @Input() row: any;
   @Input() templateName: string;

   constructor(
      protected _factoryResolver: ComponentFactoryResolver,
      protected _presenterService: PresenterService
   ) { }

   ngAfterViewInit() {
      const factory = this._factoryResolver.resolveComponentFactory(this.component);
      const ref = this.componentContainer.createComponent(factory);
      ref.instance['row'] = this.row;
      ref.instance['context'] = this.context;
      ref.instance['templateName'] = this.templateName;

      Object.assign(this._presenterService.presenterContext, {
         [this.templateName]: ref.instance
      });

   }

}

@Component({
   selector: 'kmm-dx-grid-datasource',
   template: ''
})
export class GridDataSourceComponent {

   @Input() module: string;
   @Input() operation: string;

   constructor() { }

}

